export default {
  "A confirmation code has just been sent to you by message": "Un codice di conferma ti è appena stato inviato tramite messaggio",
  "Already have an account": "Hai già un account",
  "Beyond this time, the reservation we retain will be available again for others": "Trascorso questo termine, la prenotazione da noi conservata sarà nuovamente disponibile per altri",
  "Book now": "Prenota ora",
  "Booking": "Prenotazione",
  "Booking information": "Informazioni sulla prenotazione",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "La prenotazione inizia il primo giorno alle {startTime} e termina l’ultimo giorno alle {endTime}",
  "Cancel booking": "Annulla la prenotazione",
  "Choose your date": "Scegli la tua data",
  "Confirm my phone number": "Conferma il mio numero di telefono",
  "Confirm my registration": "Conferma la mia registrazione",
  "Confirm my booking": "Conferma la mia prenotazione",
  "Confirm my registration and pay": "Conferma la mia registrazione e paga",
  "Continue as guest": "Continua come ospite",
  "Continue to registration": "Prosegui con la registrazione",
  "Create an account": "Creare un account",
  "Dates": "Date",
  "End Date of Reservation": "Data di fine della prenotazione",
  "Enlarge map": "Ingrandisci la mappa",
  "Enter your code here to confirm your registration": "Inserisci qui il tuo codice per confermare la tua registrazione",
  "I accept the Terms and conditions of registration": "Accetto i Termini e le condizioni di registrazione",
  "I accept the terms of service and confirm that I have read the privacy policy": "Accetto i termini del servizio e confermo di aver letto l’informativa sulla privacy",
  "Loading…": "Caricamento…",
  "Location": "Posizione",
  "More information": "Maggiori informazioni",
  "No slots available": "Nessuno slot disponibile",
  "Processing booking…": "Elaborazione della prenotazione…",
  "Processing payment…": "Elaborazione del pagamento…",
  "Product": "Prodotto",
  "Recording payment…": "Registrazione pagamento…",
  "Reduce map": "Riduci la mappa",
  "Remaining time": "Tempo rimanente",
  "Required fields": "Campi richiesti",
  "Reserving a product is mandatory for registration": "La prenotazione di un prodotto è obbligatoria per la registrazione",
  "Retrieving available slots": "Recupero degli slot disponibili",
  "Saving registration…": "Salvataggio della registrazione…",
  "Select size first": "Seleziona prima la taglia",
  "Select stage first": "Seleziona prima la fase",
  "Select your options and dates to book": "Seleziona le opzioni e le date per prenotare",
  "Size": "Misurare",
  "Slot": "Fessura",
  "Stage": "Palcoscenico",
  "Store": "Negozio",
  "Start Date of Reservation": "Data di inizio della prenotazione",
  "View privacy policy": "Visualizza l’informativa sulla privacy",
  "View terms and conditions": "Visualizza termini e condizioni",
  "You do not want to create an account": "Non vuoi creare un account",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "Il prodotto selezionato è stato messo da parte per te. Hai {minutes} minuti per completare il processo fornendo le tue informazioni personali nella pagina successiva.",
  "Your reservation is in progress!": "La tua prenotazione è in corso!",
  "not available": "non disponibile",
  "remaining place": "posto rimanente|posti rimanenti",
  "see availability": "vedi disponibilità",
  "Email Address": "Indirizzo Email",
  "Phone": "Telefono",
  "Birthdate": "Data di nascita",
  "ProductTypes": "Tipi di prodotto",
  "Sizes": "Dimensioni",
  "Filter": "Filtro",
  "Select a date": "Seleziona una data",
  "Give us your opinion": "Facci sapere cosa ne pensi",
  "Thank you for your review!": "Grazie per la tua opinione",
  "You can also review these products": "Puoi anche recensire questi prodotti",
  "Undo": "Annulla",
  "Redo": "Ripeti",
  "Bold": "Grassetto",
  "Italic": "Corsivo",
  "Strikethrough": "Barrato",
  "Paragraph": "Paragrafo",
  "Add Link": "Aggiungi link",
  "Remove Link": "Rimuovi link",
  "Headings": "Intestazioni",
  "Heading 2": "Intestazione 2",
  "Heading 3": "Intestazione 3",
  "Heading 4": "Intestazione 4",
  "Heading 5": "Intestazione 5",
  "Heading 6": "Intestazione 6",
  "Bullet List": "Elenco puntato",
  "Numbered List": "Elenco numerato",
  "Clear Formatting": "Cancella formattazione",
  "Overall Rating": "Valutazione complessiva",
  "Review title": "Titolo della recensione",
  "Summarize your impression on the product": "Riassumi la tua impressione sul prodotto",
  "Your detailed product review": "La tua recensione dettagliata del prodotto",
  "50 characters minimum": "50 caratteri (minimo)",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "Qual è stata la tua impressione del prodotto durante il test? Cosa ti è piaciuto o non ti è piaciuto del prodotto? Quali condizioni erano presenti durante il test del prodotto?",
  "50 characters (minimum)": "50 caratteri (minimo)",
  "Comments": "Commenti",
  "Comments on the reception, the organization, the advice on the product…": "Commenti sulla ricezione, l’organizzazione, i consigli sul prodotto…",
  "Would you recommend this product to a friend?": "Consiglieresti questo prodotto a un amico?",
  "Would you be ready to buy this product?": "Saresti disposto ad acquistare questo prodotto?",
  "First name or pseudo": "Nome o pseudonimo",
  "Your name / nickname is published with your review": "Il tuo nome / soprannome viene pubblicato con la tua recensione",
  "I have read and I accept the terms and conditions": "Io ho letto e accetto i termini e le condizioni",
  "of publication of the reviews": "della pubblicazione delle recensioni",
  "and": "e",
  "the privacy policy": "l’informativa sulla privacy",
  "Post Review": "Pubblica recensione",
  "Very bad": "Molto cattivo",
  "Bad": "Cattivo",
  "Average": "Media",
  "Good": "Buono",
  "Great!": "Ottimo!",
  "Image caption": "Didascalia dell’immagine",
  "No": "No",
  "Yes": "Sì",
  "This site is protected by reCAPTCHA.": "Questo sito è protetto da reCAPTCHA.",
  "Google Privacy Policy": "Norme sulla privacy di Google",
  "Google Terms of Service": "Termini di servizio di Google",
};
